<template>
	<main class="painel-container">
		<div class="painel-header">
			<h1>Painéis de dados estatísticos do Registro Civil</h1>
		</div>
		<div class="painel-content">
			<transition>
				<div class="painel-content__cards">
					<ServiceCard
						v-for="(card, index) in serviceCards"
						:key="index"
						:iconType="card.icon"
						:title="card.title"
						:description="card.description"
						:id="card.id"
						:route="card.route"
					/>
				</div>
			</transition>
		</div>
	</main>
</template>

<script setup>
import {ref } from 'vue';
const serviceCards = ref([
	{
		title: 'Registre-se',
		description: '',
		icon: 'registre',
		id: '534',
		route: '/registrese',
	},
	{
		title: 'Nascimentos',
		description: '',
		icon: 'baby',
		id: null,
		route: '/colecoes-nascimentos',
	},
	{
		title: 'Casamentos',
		description: '',
		icon: 'link',
		id: '567',
		route: '/casamentos',
	},
	{
		title: 'Óbitos',
		description: '',
		icon: 'flower',
		id: '568',
		route: '/obitos',
	},
	{
		title: 'Carga de legado',
		description: '',
		icon: 'file',
		id: '569',
		route: '/carga-legado',
	},
	{
		title: 'Mudança de gênero',
		description: '',
		icon: 'gender',
		id: '570',
		route: '/mudanca-genero',
	},
	{
		title: 'Unidades Interligadas',
		description: '',
		icon: 'unidades-interligadas',
		id: '533',
		route: '/unidades-interligadas',
	},
	{
		title: 'União Estável',
		description: '',
		icon: 'uniao-estavel',
		id: '535',
		route: '/uniao-estavel',
	},
	{
		title: 'Pedidos de Certidões',
		description: '',
		icon: 'certificate',
		id: null,
		route: '/pedidos-certidoes',
	}
])

</script>
<style lang="scss" scoped>
	* {
		box-sizing: border-box;
		margin: 0;
		padding: 0;
		font-family: 'Roboto', Arial, Helvetica, sans-serif;
	}

	.painel {

		&-container {
			display: flex;
			flex-direction: column;
			align-items: center;
			padding-top: 110px;
			width: 100%;
		}

		&-header {
			& h1 {
				font-size: 32px;
				line-height: 40px;
				font-weight: 700;
			}

			margin-bottom: 50px;
		}

		&-content {
			display: flex;
			flex-direction: column;
			width: 100vw;
			align-self: center;
			margin: 0 auto;

			&__cards {
				display: flex;
				flex-direction: row;
				flex-wrap: wrap;
				justify-self: center;
				justify-content: start;
				max-width: 1048px;
				margin: 0 auto;
				gap: 16px;

				@media screen and (max-width: 1280px) {
					justify-content: center;
				}
			}

			margin-bottom: 90px;

			&__button {
				width: 136px;
				height: 48px;
				padding: 12px;
				border-radius: 8px;
				border: 1px solid #155F6A;
				background: #FFFFFF;
				font-weight: 700;
				font-size: 16px;
				line-height: 24px;
				color: #155F6A;
				transition: .25s;
				margin-left: 32px;

				&:hover {
					background: #155F6A;
					color: #FFFFFF;
				}
			}
		}
	}

	.v-enter-active,
	.v-leave-active {
		transition: opacity 0.5s ease;
	}

	.v-enter-from,
	.v-leave-to {
		opacity: 0;
	}
</style>
